export const artworkWidths = [96, 192, 384, 768, 1536] as const;
export function artworkSrcSet(src: string): string | undefined {
  if (!/\.responsive-v1\/768\.webp$/.test(src)) return undefined;
  return artworkWidths.map(width => `${src.replace(/768\.webp$/, `${width}.webp`)} ${width}w`).join(', ');
}
